import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-signup-page",
    templateUrl: "./signup-page.component.html",
    styleUrls: ["./signup-page.component.scss"],
})
export class SignupPageComponent {
    readonly socialEnabled = environment.enableSocialLogin && !!environment.apiUrl;
    returnUrl: string | null = null;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly auth: AuthService,
    ) {
        this.route.queryParamMap.subscribe((params) => {
            this.returnUrl = params.get("returnUrl");
        });
    }

    onAuthenticated(): void {
        this.auth.navigateAfterAuth(this.returnUrl);
    }
}
